import React from "react";
import './WhyChooseUs.css';
import { Container, Row, Col } from "react-bootstrap";

const steps = [
  {
    title: "STEP 01 – Choose Your Vehicle",
    description: (
      <>
        Browse our ready stock or request sourcing from Japanese auctions and dealer networks.
        <br /><br />
        ✔ Verified mileage<br />
        ✔ Auction grade disclosed<br />
        ✔ Real photos & details<br /><br />
        ✔ WhatsApp<br />
        ✔ Email<br />
        ✔ Website inquiry
      </>
    )
  },
  {
    title: "STEP 02 – Send Inquiry",
    description: "Our export team confirms availability, condition, and destination eligibility."
  },
  {
    title: "STEP 03 – Price & Invoice Confirmation",
    description: (
      <>
        Receive a transparent Proforma Invoice with FOB or CIF pricing.
        <br /><br />
        ✔ No hidden charges<br />
        ✔ Shipping & documents included<br /><br />
        ✔ Official Japan bank account<br />
        ✔ Secure international transfer
      </>
    )
  },
  {
    title: "STEP 04 – Secure Payment",
    description: "Payments are made only to verified company accounts in Japan."
  },
  {
    title: "STEP 05 – Inspection & Shipment",
    description: (
      <>
        Vehicle is inspected, documented, and shipped via RORO or container.
        <br /><br />
        ✔ Export inspection<br />
        ✔ Port loading photos<br /><br />
        ✔ Original documents couriered<br />
        ✔ Smooth customs clearance
      </>
    )
  },
  {
    title: "STEP 06 – Documents & Delivery",
    description: "Receive original export documents and clear your vehicle smoothly."
  }
];

const WhyChooseUs = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h2 className="text-center mb-4">
            6-Step Smart Buying System
          </h2>
          <p className="text-center mb-5">
            A structured, transparent, and buyer-friendly system designed for international vehicle imports.
          </p>

          <div className="main-timeline">
            {steps.map((step, index) => (
              <div className="timeline" key={index}>
                <div className="timeline-icon"></div>
                <div className="timeline-content">
                  <h3 className="title">{step.title}</h3>
                  <p className="description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;